import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTranslation } from "react-i18next"
import { LanguageService } from "services/languageService"
import { Globe } from "lucide-react"
import { cn } from "@/lib/utils"

const languages = [
  { code: "en", name: "English" },
  { code: "pt", name: "Português (BR)" },
]

interface LanguagePickerProps {
  collapsed?: boolean
}

export function LanguagePicker({ collapsed = false }: LanguagePickerProps) {
  const { i18n } = useTranslation()
  const currentLanguage = languages.find((l) => l.code === i18n.language) || languages[0]

  const handleLanguageChange = (languageCode: string) => {
    LanguageService.markUserChoice()
    LanguageService.saveLanguage(languageCode)
    i18n.changeLanguage(languageCode)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-menu-trigger"
        className={cn(
          "flex items-center gap-2.5 rounded-md text-[13px] text-foreground/70 transition-colors hover:bg-accent hover:text-foreground focus:outline-none",
          collapsed ? "justify-center p-2" : "w-full px-2.5 py-[7px]"
        )}
      >
        <Globe className="h-4 w-4 shrink-0 opacity-60" />
        {!collapsed && <span className="truncate">{currentLanguage.name}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        side={collapsed ? "right" : "top"}
        className="w-[200px]"
        data-testid="language-menu"
      >
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            data-testid={`language-option-${language.code}`}
            className="cursor-pointer"
            onClick={() => handleLanguageChange(language.code)}
          >
            {language.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
